<template lang="html">
  <div id="results-page">

    <!-- <section class="breadcrumb-section">
      <div class="container oversized-container">
        <router-link to="/">Home</router-link>
        <span class="line">/</span>
        <span>Promociones</span>
      </div>
    </section> -->

    <section class="container oversized-container products-section">
      <div class="row mb-3">
        <div class="col-12 col-s-title">
          <h2 class="title">Promociones</h2>
        </div>
      </div>

      <div class="row" v-if="isLoading">
        <div class="col-12">
          <loading-component></loading-component>
        </div>
      </div>

      <div class="row" v-else>  
        <!-- <iframe :src="pdf" width="100%" height="650px"></iframe> -->
        <!-- Results -->
        <div class="col-12">
          <div class="row sample-products-wrapper xxl-5e">
            <div class="col-sm-6 col-md-4 col-lg-3 sample-product" v-for="(promo, index) in promotions" :key="index">
              <div class="outlined-box">
                <a class="box-image" :href="promo.url" target="_blank">
                  <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+promo.imageUrl+')' }" >
                    <img src="public/images/shared/empty.png" >
                  </div>
                </a>
                <p class="p-button">
                    <router-link class="btn-more" :to="'/promociones/'+promo.id">Ver productos</router-link>
                  </p>

                
              </div>
            </div>

          
          </div>
        </div>

      </div>
    </section>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },
  data(){
    return{
      isLoading: true,
      pdf:null,
      promotions:[],
    }
  },

  methods: {
    // getProducts: function(){
    //   this.isLoading = true;
    //   axios.get(tools.url('/api/novedades')).then((response)=>{
    //     this.products = response.data;
    //     this.isLoading = false;
    //   }).catch((error)=>{
    //     console.log(error);
    //     this.isLoading = false;
    //   })
    // },

    /*getPdf: function(){
      this.isLoading = true;
      axios.get(tools.url('/api/pdf')).then((response)=>{
      if(response.data.link != null){
        this.pdf = response.data.link;
      }
      else{
        this.pdf = response.data.body;
      }
        
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
        this.isLoading = false;
      })
    },*/
    getPromotions: function(){
      this.isLoading = true;
      axios.get(tools.url('/api/promotions')).then((response)=>{
        this.promotions = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
        this.isLoading = false;
      })
    },
  },

  mounted(){
    this.getPromotions();
  },
}
</script>
